import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-18 ant-col-xl-18" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"width":"700px"},
    "wrap-class-name": "ss-modal-financeiro"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.props.titulo), 1)
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmar()))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "Tipo de Documento",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_tipo_documento_financeiro, {
                empresas: _ctx.empresas,
                codigoSelecionado: _ctx.state.codigoSelecionado,
                "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.codigoSelecionado) = $event)),
                meioPagamento: _ctx.props.meioPagamento
              }, null, 8, ["empresas", "codigoSelecionado", "meioPagamento"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}